import { WizardShell } from 'components/forms';
import { useSelectedBusinessUnit } from 'contexts/SidebarContext';
import useCurrentUser from 'hooks/useCurrentUser';
import { type FC, useCallback, useState } from 'react';
import { type InsuranceQuoteFormData, initialFormData } from 'services/types/insuranceQuoteForm';

import InsuredDataStep from './components/InsuredDataStep';
import LicensePlateStep from './components/LicensePlateStep';
import QuoteResultsStep from './components/QuoteResultsStep';

const steps = ['Datos del asegurado', 'Datos del vehículo', 'Cotizaciones'];

const InsuranceQuoteForm: FC = () => {
  const currentUser = useCurrentUser();
  const { selectedBusinessUnitId: businessUnitId } = useSelectedBusinessUnit();
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState<InsuranceQuoteFormData>(initialFormData);
  const [isLoading, setIsLoading] = useState(false);

  const handleNext = useCallback(() => setActiveStep((s) => s + 1), []);
  const handleBack = useCallback(() => setActiveStep((s) => s - 1), []);
  const handleFormDataChange = useCallback((updates: Partial<InsuranceQuoteFormData>) => {
    setFormData((prev) => ({ ...prev, ...updates }));
  }, []);

  const effectiveBusinessUnitId = businessUnitId ?? currentUser?.businessUnitIds?.[0] ?? null;

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <InsuredDataStep
            formData={formData}
            businessUnitId={effectiveBusinessUnitId}
            onFormDataChange={handleFormDataChange}
            onNext={handleNext}
            setIsLoading={setIsLoading}
          />
        );
      case 1:
        return (
          <LicensePlateStep
            formData={formData}
            onFormDataChange={handleFormDataChange}
            onNext={handleNext}
            onBack={handleBack}
            setIsLoading={setIsLoading}
          />
        );
      case 2:
        return (
          <QuoteResultsStep
            formData={formData}
            businessUnitId={effectiveBusinessUnitId}
            onBack={handleBack}
            setIsLoading={setIsLoading}
          />
        );
      default:
        return null;
    }
  };

  return (
    <WizardShell
      title="Cotizar Seguro"
      subtitle="Automotriz Usados"
      steps={steps}
      activeStep={activeStep}
      isLoading={isLoading}
    >
      {renderStepContent()}
    </WizardShell>
  );
};

export default InsuranceQuoteForm;
